<template>
  <div>
    <div class="box"></div>
    <div class="box2">
      <!-- <img src="../assets/images/contact/zp.jpg" height="100%"> -->
      <div class="rit">
        <!-- <img src="../assets/images/contact/qr.jpg" class="ewm">
                          <p style="font-size: 12px">微信公众号</p> -->
        <!--                <table cellspacing="0" valign="top">-->
        <!--                    <tr>-->
        <!--                        <td style="width: .3rem;height: .55rem;padding-top:.04rem;"><i class="el-icon-location-outline"-->
        <!--                                                                                       style="font-size: .2rem;"></i>-->
        <!--                        </td>-->
        <!--                        <td style="width: .55rem;">总部：</td>-->
        <!--                        <td>广东深圳福田区八卦岭工业区八卦二路524栋5楼整层<br/>-->
        <!--                            湖南子公司： 广东深圳福田区八卦岭工业区八卦二路524栋5楼整层</td>-->
        <!--                    </tr>-->
        <!--                    <tr>-->
        <!--                        <td style="width: .3rem;height: .4rem;padding-top:.04rem;"><i class="el-icon-phone-outline"-->
        <!--                                                                                      style="font-size: .2rem;"></i>-->
        <!--                        </td>-->
        <!--                        <td style="width: .55rem;">热线：</td>-->
        <!--                        <td style="padding-top:.05rem;">0755 - 88845187 / 82913409</td>-->
        <!--                    </tr>-->
        <!--                    <tr>-->
        <!--                        <td style="width: .3rem;padding-top:.04rem;"><i class="el-icon-message"-->
        <!--                                                                        style="font-size: .2rem;"></i></td>-->
        <!--                        <td style="width: .55rem;">邮箱：</td>-->
        <!--                        <td style="padding-top:.05rem;">37378528@qq.com</td>-->
        <!--                    </tr>-->
        <!--                </table>-->

        <div class="distribution">
          <div class="wp">
            <div class="canvas-area">
              <div class="canvasWp">
                <canvas id="canvas"></canvas>
              </div>
              <div class="company-pos">
                <span
                  v-for="(item, index) in cityList"
                  :key="index"
                  :title="item.name"
                  @mouseenter="getCanvas($event, index)"
                  :data-id="item.id"
                  :class="item.id"
                  ><i>{{ item.name }}</i></span
                >
              </div>
            </div>
            <div class="company-list">
              <div
                v-for="(item, index) in cityList"
                :key="index"
                class="company-item"
                :id="item.id"
                :style="{ display: item.show ? 'block' : 'none' }"
              >
                <img :src="item.src" :alt="item.title" />
                <div class="contact-inner">
                  <h3>{{ item.title }}</h3>
                  <div class="c-phone">联系方式：{{ item.phone }}</div>
                  <div v-if="item.email" class="c-email">
                    邮箱：{{ item.email }}
                  </div>
                  <div class="c-site">地址：{{ item.site }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="box5"
      id="box5">
      <div class="tit">加入我们</div>
      <div class="bor"></div>
    </div>
    <div class="box4">
      <img src="../assets/images/contact/fl.jpg"
        style="width: 12rem; height: 4.91rem" />
    </div> -->
    <!-- <div class="box5">
      <div class="tit">招聘信息</div>
      <div class="bor"></div>
    </div>
    <div class="box3">
      <div class="main"
        v-for="(item, index) in dataList"
        :key="index">
        <div class="job">
          <div class="lef">{{ item.name }}</div>
          <div class="lef2"></div>
          <div class="lef2" v-if="item.num">人数：{{ item.num }}人</div>
          <div class="lef3">发布日期：2020-03-03</div>
          <div>
            <i class="el-icon-arrow-down"
              @click="changClick"
              style="cursor: pointer"></i>
          </div>
        </div>
        <div class="detail">
          <p class="row">
            <span>薪资：{{ item.pay }}</span>
            <span class="wid"
              v-if="item.year">工作经验：{{ item.year }}</span>
            <span style="margin-left: .2rem">工作性质：全职</span>
            <span class="wid"
              v-if="item.education">学历要求：{{ item.education }}</span>
          </p>
          [ 岗位职责 ]
          <div v-html="item.duty"></div>
          [ 任职资格 ]
          <div v-html="item.status"></div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'Contact',
  data() {
    return {
      icon: '',
      timer: '',
      dataList: [
        {
          name: '销售经理',
          pay: '20-70万/年',
          year: '',
          education: '',
          num: 2,
          date: '',
          duty:
            '1、根据分配的客户资源，跟进项目型客户，挖掘客户需求，找到关键决策人，展示公司的优势；<br>' +
            '2、开发新客户，跟进公司给的资源 ；<br>' +
            '3、为客户提供完善的项目解决方案；<br>' +
            '4、完成公司规定的销售指标、回款指标；<br>' +
            '5、签定销售合同，协调、审核与销售服务有关的事务；',
          status:
            '1、一年以上销售工作经验。优秀毕业生亦可考虑；<br>' +
            '2、具有良好的语言表达能力与沟通能力；<br>' +
            '3、吃苦耐劳、爱好学习、富有团队精神、开拓精神。<br>',
        },
        {
          name: '渠道销售经理',
          pay: '20-70万/年',
          year: '',
          education: '',
          num: 2,
          duty:
            '1、负责公司物联网产品（智慧工地云平台及智能硬件、A安全教育培训软硬件产品）的销售推广 <br>' +
            '2、负责挖掘、拓展行业内相关渠道商、代理商、合作伙伴，拓展大客户；<br>' +
            '3、负责与渠道商、代理商进行谈判、签约、维护关系等，完成公司的招商目标；<br>' +
            '4、及时了解、处理渠道商的问题并反馈给公司；<br>' +
            '5、完成领导安排的其他工作内容。<br>',
          status:
            '1、本科及以上学历；<br>' +
            '2、两年以上产品销售或渠道销售工作经验，对渠道合作有一定的理解和认识；<br>' +
            '3、性格外向，沟通协调能力强，善于主动与客户沟通，服务热情，亲和力强；<br>' +
            '4、具有很强的开拓精神、吃苦耐劳、能接受短期外地岀差。<br>',
        },
        {
          name: '大客户总监/大客户经理',
          pay: '20-100万/年',
          year: '',
          education: '',
          num: 2,
          duty:
            '1、负责公司物联网产品（智慧工地、AI安全教育、智能硬件）的销售推广。<br>' +
            '2、开发住建局、交通局、城投、万科、恒大、中建、中铁等企业级客户，定期拜访并建立良好客户关系；<br>' +
            '3、负责大客户营销合同的谈判与签订工作； <br>' +
            '4、负责大客户销售团队的建设、培养、激励措施、培训、监督指导',
          status:
            '1、本科及以上学历。<br>' +
            '2、具有3年以上集团企业级大客户的开发经验。<br>' +
            '3、具备卓越的客户扩展能力，优秀的沟通能力、谈判技巧。<br>' +
            '4、具备良好的市场分析判断能力，能及时把握市场机会。',
        },
        {
          name: '销售助理',
          pay: '6-12K/月',
          year: '',
          education: '',
          num: 2,
          duty:
            '1、协助销售总监进行业务开发相关工作<br>' +
            '2、对公司的客户定期进行跟踪、维护，保持联络；<br>' +
            '3、对公司的客户信息，进行跟踪、维护、洽谈，协助业务人员促成合作；<br>' +
            '4、跟进公司的项目进度，跟进生产部门让项目圆满交付；<br>' +
            '5、通过电话、网络等渠道收集、筛选意向项目信息；<br>' +
            '6、完成领导交办的其他任务。<br>',
          status:
            '1、大专及以上学历，有潜质的应届毕业生可择优考虑；<br>' +
            '2、性格外向、积极主动、工作仔细、责任心强，能承受一定的工作压力；<br>' +
            '3、普通话标准，具备良好的沟通与表达能力；<br>' +
            '4、能通过电话、面谈与客户进行良好沟通并了解客户需求寻求销售机会；<br>' +
            '5、有较强的学习能力，对业务跟单、业务开发、业务管理有浓厚兴趣；<br>' +
            '6、熟练使用WORD、 EXCEL、PPT等办公软件。<br>',
        },

        {
          name: '施工技术总工/BIM工程师/安全主任',
          pay: '20-70万/年',
          year: '',
          education: '',
          num: 2,
          duty:
            '1.参与智慧工地平台开发；<br>' +
            '2、参与智慧工地相关的物联网、智能硬件产品、软件开发工作；<br>' +
            '3、智慧工地产品研发讨论，根据业主需求提出产品设想及框架搭建；<br>' +
            '4．参与公司智慧工地产品宣传资料整理、设计工作；<br>' +
            '5、参与工程建设行业的技术交流、论坛会议等；<br>' +
            '6、负责项目的需求对接，项目需求信息的获取、分析等；<br>' +
            '7、在公司办公，不用去工地；<br>' +
            '8、去工地跟施工单位、总包方、业主对接智慧工地项目的各种需求；<br>' +
            '9、要做一些智慧工地的技术方案（要会CAD、PPT软件）。',
          status:
            '1、本科及以上学历，土木工程、工程管理、桥隧等相关专业；<br>' +
            '2、建筑施工单位两年以上技术经验及现场工作经验，技术总工优先；<br>' +
            '3、对互联网、物联网、建筑信息化有了解，对智慧工地产品研发有兴趣；<br>' +
            '4．能熟练运用CAD软件，有PPT方案、BM及施工信息经验优先。',
        },
        {
          name: '3D动画师',
          pay: '10-20K/月',
          year: '',
          education: '',
          num: 2,
          duty:
            '1、熟悉渲染及动画制作，能够胜任3D建筑模型材质，灯光，动画，各种3D渲染工具的渲染及镜头素材的后期制作；<br>' +
            '2、配合项目制作需求，负责动画产品的3D场景，镜头及动画的渲染工作；<br>' +
            '3、根据市场部反馈的影片需求营造各种3D场景气氛，并对质量负责；<br>' +
            '4、能够独立完成影片所需3D场景里的动画制作；<br>' +
            '5、根据项目或产品的需要，协助进行各种新技术的研发工作；<br>' +
            '6、根据项目或产品的需要，协助收集各种3D资料；<br>' +
            '7、参与动画脚本设计。<br>',
          status:
            '1、大专及以上学历，建筑学、环境艺术、美术或相关专业毕业；<br>' +
            '2、熟练应用3DMAX等相关软件，掌握VRAY或其他渲染器，精通粒子、动力学、流体等特效模埉；熟练掌握粒子系统等特效技术者优先或会手绘原画基础的优先；<br>' +
            '3、有较强的理解能力及创意思维；<br>' +
            '4、具有较强的色彩把握及意境控制能力，具备丰富的动画制作技术及经验，对模型、后期流程有较好地了解；<br>' +
            '5、具备良好的团队意识及服务理念，良好的职业道德及文化素养，愿意尝试新鲜事物；具备一定的沟通能力；<br>' +
            '6、要求提交部分个人作品；热衷于施工行业；希望能长期发展。<br>',
        },
        {
          name: '影视后期合成师',
          pay: '10-20K/月',
          year: '',
          education: '',
          num: 2,
          duty:
            '1、完成公司动画视频后期制作与合成;<br>' +
            '2、根据项目主题需要，分析、收集和整理相关视频资料。',
          status:
            '1、本科学历，艺术院校影视后期等相关专业;<br>' +
            '2、两年及以上相关工作经验，美术功底扎实，拥有丰富的合成、剪辑经验，对音乐和镜头语言的节奏具有良好的感知能力，具备较高的视听审美标准；<br>' +
            '3、能够独立完成宣传片、专题片等后期制作者优先4.能吃苦耐劳、品行端正、能适应必要的加班、具有团队协作精神。',
        },
        {
          name: '硬件开发工程师',
          pay: '10-30K/月',
          year: '',
          education: '',
          num: 2,
          duty:
            '1、熟练使用 ORCAD、PADS等软件；<br>' +
            '2、有工业级产品或者物联网产品经验优先；<br>' +
            '3、独立完成公司项目的方案设计、物料选型、原理图设计、PCB设计，以及相关的调试工作；<br>' +
            '4、负责公司一些基础研究项目的技术攻关；<br>' +
            '5、编写相关硬件文档；<br>' +
            '6、支持产品的研发转量产，解决试产中遇到的各种问题。',
          status:
            '1、本科以上学历，自动化、电子及通信类相关专业毕业；<br>' +
            '2、精通模拟电子技术和数字电子技术；<br>' +
            '3、对传感器有一定的了解，具有一定电路知识，独立分析电路工作原理；<br>' +
            '4、具备STM32等相关单片机软件的程序设计相关经验者优先；<br>' +
            '5、大学期间参加过电子设计大赛、机器人等赛事的优先考虑。',
        },
        {
          name: '嵌入式软件工程师',
          pay: '10-20K/月',
          year: '',
          education: '',
          num: 2,
          duty:
            '1、负责智能硬件产品嵌入式软件开发工作；<br>' +
            '2、与其他团队成员（软件、工程部同事等）合作完成项目任务。<br>' +
            '3、辅助现场工程解决用户问题。',
          status:
            '1、本科及以上学历，计算机、自动化、通信、电子电气类专业；<br>' +
            '2、嵌入式开发3年工作经验；<br>' +
            '3、特别精通C、C++编程，有丰富的软件开发、架构设计经验；<br>' +
            '4、熟练掌握一种或多种嵌入式操作系统，如 FREERTOS,RT-THREAD, LINUX等；<br>' +
            '5、了解LINUX下 SHELL、内核裁剪、文件系统、 BOOTLOADER，会使用进程间通讯、多线程编程；<br>' +
            '6、在 GITHUBGITEE上有开源项目优先。',
        },
        {
          name: '嵌入式软件测试工程师',
          pay: '6-8K/月',
          year: '',
          education: '',
          num: 2,
          duty:
            '1、根据项目需要编写测试计划、测试方案、测试报告；<br>' +
            '2、按照质本科及以上学历，电子、计算机技术、汽车类相关专业；量标准进行文档的编写、修订和标准化工作；<br>' +
            '3、根据项目需要独立进行需求分析、测试用例设计工作；<br>' +
            '4、按照测试计划完成各类测试（功能、性能、安全、稳定性等）的执行与测试结果的记录；<br>' +
            '5、使用工具对软件版本进行配置管理与发布；<br>' +
            '6、使用工具进行缺陷追踪与管理；<br>' +
            '7、根据项目需要进行测试环境的准备与维护；<br>' +
            '8、负责测试日志的编写与汇总；<br>' +
            '9、根据项目需要进行项目管理工作。',
          status:
            '1、本科及以上学历，电子、计算机技术、汽车类相关专业；<br>' +
            '2、熟悉C语言开发，熟悉嵌入式软件开发；<br>' +
            '3、良好的沟通能力，具有团队合作精神。',
        },
        {
          name: '硬件测试工程师',
          pay: '6-8K/月',
          year: '',
          education: '',
          num: 2,
          duty:
            '1、负责具体硬件产品的测试工作，有良好的焊接水平，对样板进行调测；<br>' +
            '2、负责产品在研发和试产阶段的硬件测试工作，编写硬件测试方案，测试完成后编写测试报告；<br>' +
            '3、负责对产品硬件单板、功能模块、硬件系统及整机进行性能、功能及可靠性等测试；<br>' +
            '4、整机功能性能测试、参与测试规范的制定，协助研发并跟进解决测试中的问题；<br>' +
            '5、协助研发完善标准和规范，编写测试用例、测试计划；<br>' +
            '6、负责公司返修硬件产品的检测，问题定位，跟进维修团队处理解决；<br>' +
            '7、定期给技术部培训硬件相关知识。',
          status:
            '1、大专及以上学历，物联网、自动化、通信、电子技术、机电、等相关专业毕业；<br>' +
            '2、有良好数电、模电基础，熟悉相关领域的基本理论知识；能看慬电路图；熟悉并掌握各种測试仪器的使用；动手能力强，具备一定的焊接能力；<br>' +
            '3、熟练使用各种常规仪器，如万用表、示波器、电子负载等，有一定的测试文档输出能力；<br>' +
            '4、工作努力积极并有高度的团队合作精神，有较强的学习能力与解决问题的能力，具有良好的沟通意识。',
        },
        {
          name: '前端开发工程师',
          pay: '10-20K/月',
          year: '',
          education: '',
          num: 2,
          duty:
            '1、负责WEB前端界面、小程序的构建，交互设计与实现；<br>' +
            '2、负责各产品的界面维护、易用性改造，模块化设计和性能优化；<br>' +
            '3、负责涉及到的相关新技术研究、功能扩展与优化。',
          status:
            '1、本科以上学历，计算机等相关专业；<br>' +
            '2、熟练运用 JAVASCRIPT语言与HTML5、CSS3等技术；<br>' +
            '3、熟悉WEB绘图相关高级特性，如 CANVAS, WEBGL,CSS3动画效果等；<br>' +
            '4、熟悉模块化、前端编译和构建工具，如：WEBPACK. GULP、GRUN等；<br>' +
            '5、熟练运用主流的移动端JS库和开发框架，并深入理解其设计原理，如：VUE、 REACT、 ANGULAR、 BOOTSTRAP等；<br>' +
            '6、对模块化、重构、性能优化、跨浏览器兼容、提高系统的扩展性有丰富经验；<br>' +
            '7、良好的沟通能力，具有良好的团队协作精神。',
        },
        {
          name: '后端开发工程师',
          pay: '10-20K/月',
          year: '',
          education: '',
          num: 2,
          duty:
            '1、组织 LINUXWEB服务器搭建方案及方案实施，能根据需求提出服务器及数据库配置方案并实施；<br>' +
            '2、JAVAWEB后端功能实现，如账户管理、流媒体资源管理、数据递交计算；<br>' +
            '3、参与运营后的系统维护与升级。',
          status:
            '1、本科及以上学历，计算机、软件等相关专业；<br>' +
            '2、一年以上WEB后端开发经验，精通JAVA并熟悉 SPRING、SPRING-MVC或 MYBATLS框架；<br>' +
            '3、熟悉WEB绘图相关高级特性，如 CANVAS, WEBGL,CSS3动画效果等；<br>' +
            '4、了解后端管理，如服务器的安全、迁移与部署等；<br>' +
            '5、了解流媒体技术，对基础网络、存储、数据库等某一领域有较深入的实践能力；<br>' +
            '6、善于沟通，有较强团队意识；<br>' +
            '7、对技术有激情，喜欢钻研，主动性高，具有较强的独立工作能力和解决问题的能力。',
        },
        {
          name: '运维工程师',
          pay: '6-8K/月',
          year: '',
          education: '',
          num: 2,
          duty:
            '1、负责线上系统的日常运维，包括部署、变更、监控和告警处理等；<br>' +
            '2、完善监控系统，提高监控有效性及时发现故障，保障业务可用；<br>' +
            '3、对日常问题分析汇总，提出更优方案，并推动落地；<br>' +
            '4、参与架构优化、容灾优化、性能优化等项目，分析系统瓶颈、容量评估完成扩容、架构、改造等工作；<br>' +
            '5、参与自动化运维体系建设，开发运维工具。',
          status:
            '1、大专及以上学历，计算机相关专业优先；<br>' +
            '2、两年以上互联网行业的运维经验，工作细致踏实，有较强的沟通，执行能力；<br>' +
            '3、熟悉LINUX系统，熟悉TCP/P、HTTP协议工作原理；<br>' +
            '4、熟悉使用LINUX系统下各种应用，如NGINX、 TOMCAT、REDIS、 KEEPALIVES、IPTABLES、 MYSQL；<br>' +
            '5、熟悉使用 SHELL，并掌握 PYTHON/GO任意一门编程语言；<br>' +
            '6、有K8S、 DOCKER使用经验；',
        },
        {
          name: '安装调试工程师',
          pay: '8-10K/月',
          year: '',
          education: '',
          num: 2,
          duty:
            '1、确定项目施工条件，跟踪货物物流信息，组织安装、调试、调度以及施工现场的安全管理和文明施工管理，组织项目的竣工验收，确保施工项目按时按质完成；<br>' +
            '2、负责协调项目联系人确认现场是否满足安装条件；<br>' +
            '3、负责与总控组确认硬件设备是否已到项目现场；<br>' +
            '4、负责向项目签收硬件送货单；<br>' +
            '5、负责完成合同内硬件设备的安装、调试；<br>' +
            '6、负责项目验收，与项目签收验收单，交与总控组；<br>' +
            '7、新旧项目新增设备，维护产生的硬件成本、人工成本反馈给总控组；<br>' +
            '8、负责总控组安排的相关项目售后；<br>' +
            '9、上级安排的其它临时工作。',
          status:
            '1、有一年以上智能安防监控、智能电子抓拍、门禁及数字审讯系统、联网报警系统的施工经验；<br>' +
            '2、从事过安防项目指导及负责；<br>' +
            '3、熟悉路由器、交换机、电话交换机安装和网络布线等；<br>' +
            '4、积极主动，认真负责；<br>' +
            '5、能够适应短期省内出差，并尽职尽责按时完成公司领导交办的临时性工作。',
        },
        {
          name: '弱电项目经理',
          pay: '8-15K/月',
          year: '',
          education: '',
          num: 2,
          duty:
            '1、具备建筑、工程项目管理能力及经验，熟练掌握建筑工程斾工及验收规范；<br>' +
            '2、具有独立进行项目管理、协调和运作的能力，并具备忠诚敬业的职业道德；<br>' +
            '3、善于沟通和协调各方关系，能够及时处理各方配合和施工过程中出现的各种问题，完成公司委派的项目施工任务；<br>' +
            '4、负责公司委派的单个项目协调、运作、调度、协助及签回验收单管理；<br>' +
            '5、为确保项目能准确施工，能对施工现场进行排查，并与项目沟通施工配合的事项；<br>' +
            '6、完成领导临时安排的工作任务。',
          status:
            '1、大专及以上学历，工程类或建筑类相关专业；<br>' +
            '2、两年以上建筑、工程项目管理经验，有中铁、中建、中交等央企工程项目管理经验更佳；<br>' +
            '3、良好的计划和执行能力、协调能力和人际沟通能力；<br>' +
            '4、积极主动，具备团队意识，具有高度的责任心，能够承受较强的工作压力。',
        },
        {
          name: '产品经理/助理',
          pay: '8-20K/月',
          year: '',
          education: '',
          num: 2,
          duty:
            '1、负责需求对接，需求分析；<br>' +
            '2、根据客户需求，进行需求分析，能根据需求快速形成产品原型；<br>' +
            '3、撰写需求文档，功能设计，原型示例，策划方案等，改进产品功能和用户体验；<br>' +
            '4、负责产品落地跟进，与开发、UI、测试沟通协调，跟进产品研发进度，督促产品快速落地3.分析人工智能，智慧建筑，智能工程等行业动态，研究竞争对手产品和市场策略；<br>' +
            '5、分析行业需求，规划定义产品形态，应用，生命周期；<br>' +
            '6、良好的客户需求分析，挖掘能力。',
          status:
            '1、本科及以上学历，计算机、电子、自动化、通信及建筑类等相关专业；<br>' +
            '2、有2年以上的产品工作经验，有B端或者智慧工地相关产品工作经验更好；<br>' +
            '3、熟练掌握 AXURERP、VISIO等原型设计工具，善于产品PPT，持续优化产品，提升易用性；<br>' +
            '4、性格开朗，工作积极主动，良好的沟通表达能力，有较强的团队合作精神。',
        },
        {
          name: '采购主管',
          pay: '8-15K/月',
          year: '',
          education: '',
          num: 2,
          duty:
            '1、编制季度采购预算，实施采购的预防控制和过程控制，有效降低成本；<br>' +
            '2、负责根据需求计划和经营计划的要求制定采购计划，保证各种物资及时充足供应；<br>' +
            '3、负责选择与评估供应商，签订釆购合同，并建立供应商档案，维护良好的客户关系；<br>' +
            '4、根据釆购计划，保质、保量、及时的进行采购，及时解决与供应商之间的各种问题；<br>' +
            '5、制定和完善部门的各项制度和流程，并监督检查执行情况；<br>' +
            '6、负责部门人员的队伍建设，提出对下属人员的调配、培训、考核；<br>' +
            '7、完成上级领导安排的其它工作',
          status:
            '1、本科及以上学历；3年以上物资管理相关工作经验；<br>' +
            '2、具有良好的沟通、协调和人际交往能力；较强的谈判能力、独立分析和解决问题能力；<br>' +
            '3、有釆购管理经验，熟悉物资采购招投标程序和本公司的生产经营计划；',
        },
        {
          name: '采购专员',
          pay: '7-10K/月',
          year: '',
          education: '',
          num: 2,
          duty:
            '1、负责采购下单，下单后的订单跟踪到货；处理订单到货后的异常情况；<br>' +
            '2、起草采购合同并上报；<br>' +
            '3、采购物资的验收工作，协助质量管理部以及相关仓储部门人员进行采购物资的验收以及入库；<br>' +
            '4、进行市场调研，开拓采购渠道，选择有质量、品质以及合理价格的供货商，确保合作供应商的资质正确、产品质量达标、售后规范等；<br>' +
            '5、对采购相关文档资料进行收集、整理和存档；<br>' +
            '6、负责所采购产品信息系统的建立、维护和保密工作。',
          status:
            '1、采购、物流相关专业全日制大专及以上学历；有从事有建筑施工行业采购两年以上工作经验、供应商招标经验者优先；<br>' +
            '2、具有一定的沟通谈判能力与执行能力以及一定的供应商关系管理能力；良好的责任感和团队精神，做事有条理，认真细致；<br>' +
            '3、熟悉相关合同条款，能制作商务招标书以及合同书。',
        },
        {
          name: '商务专员',
          pay: '7-10K/月',
          year: '',
          education: '',
          num: 2,
          duty:
            '1、依据公司实际情况辅助部门经理起草动画和VR合同及商务工作需要的各种单据；<br>' +
            '2、根据合同、或生产确认单，每周定期更新项目清单汇总表给到部门经理；<br>' +
            '3、及时提交工作总结及计划安排周报表，月报表交由部门经理审查与考核；<br>' +
            '4、定期跟踪订单生产完成情况并对于已完工项目及时办理结算收款。',
          status:
            '1、全日伟本科及以上学历，建筑类、市场营销、财务、商务管理类相关专业；<br>' +
            '2、1年以上相关领域工作经验，有大型国企建筑业工作经历者优先考虑；<br>' +
            '3、良好的口头及书面表达能力，熟练使用各种办公软件；<br>' +
            '4、良好的沟通与协调的能力、分析与解决问题的能力；<br>' +
            '5、较强的谈判技巧，耐心、思路清晰，能承受一定的工作压力。',
        },
        {
          name: '商务外协专员',
          pay: '8-15K/月',
          year: '',
          education: '',
          num: 2,
          duty:
            '1、负责项目回款推进工作等，确保公司年度回款任务达成；<br>' +
            '2、负责项目回款过程中的信息收集、数据分析、异常跟进及问题处理等，对项目回款完成情况负责；<br>' +
            '3、负责协调业务部和商务部回款相关事宜；<br>' +
            '4、与客户签订回款结算资料，及时监督客户回款；<br>' +
            '5、负责按时、按质与按量的完成上级领导交办的其他事项；',
          status:
            '1、35岁以下，全日制大专及以上学历，市场营销管理等相关专业；<br>' +
            '2、熟悉项目收款流程，会开车；<br>' +
            '3、具备项目沟通、组织、协调及管理能力，责任心强，执行力高；<br>' +
            '4、思维清晰、沟通顺畅、对数据敏感；<br>' +
            '5、二年（含）以上工作经验，有项目管理相关工作经验者优先。',
        },
        {
          name: '应收会计',
          pay: '7-13K/月',
          year: '',
          education: '',
          num: 2,
          duty:
            '1、根据公司会计核算规范的要求，负责公司销售收入及销项税金、应收账款及坏账的确认及日常及时核算；<br>' +
            '2、负责制定销售回款计划，负责督促商务及业务部门的应收账款催收；<br>' +
            '3、维护并定期更新销售及应收账款管理制度，统筹管理公司及分公司收入核算的规范性；<br>' +
            '4、负责审核公司销售合同及订单，保证财务结算资料的合规性、完整性、准确性；<br>' +
            '5、及时编制并定期提供销售收入相关汇总及分析报表（销售收入构成、应收账款周转率、坏账管理、账齡分析）等，及时并定期提醒坏账风险；<br>' +
            '6、负责拟定开票计划，审核开票申请；<br>' +
            '7、负责销售合同、确认函、完工验收单、项目结算单等档案的有序管理；' +
            '8、负责协助销售及应收有关审计事务，并负责解释',
          status:
            '1、会计审计财务管理等相关专业，全日制大专以上学历，本科学历者优先；<br>' +
            '2、具备往来会计/应收会计、主办会计岗位3年以上工作经验；<br>' +
            '3、具备初级会计职称以上职称，有中级会计师以上职称者优先；<br>' +
            '4、熟练使用金蝶、用友等财务软件或企业ERP系统；<br>' +
            '5、熟悉 OFFICE办公软件的操作，熟悉掌握 EXCELI函数的运用；<br>' +
            '6、对数字敏感，财务逻辑思维能力较强，具备通过业务洞察进行财务分析的能力7.具备诚实、正直的品格，以及细致、严谨的专业精神。',
        },
        {
          name: 'ERP工程师',
          pay: '10-30K/月',
          year: '',
          education: '',
          num: 2,
          duty:
            '1、负责公司内部ERP系统实施和推动工作；<br>' +
            '2、帮助用户梳理业务流程，提供改善建议和业务解决方案；<br>' +
            '3、协助统筹承担企业内部订单、CRM、供应链、财务模块等项目实施工作，出具需求调研报告、实施方案等文档；<br>' +
            '4、培训和指导用户进行系统的操作及日常问题处理；<br>' +
            '5、完成上级交待的其它工作。',
          status:
            '1、全日制本科及以上学历，计算机及管理相关专业；<br>' +
            '2、具有3年以上信息系统集成/工程管理ERP项目实施经验，有大中型企业实施经验者优先；<br>' +
            '3、熟悉供应链、财务业务，有相关领域应用经验，有项目管理经验优先；<br>' +
            '4、具有强项目控制能力及沟通协调能力；<br>' +
            '5、熟悉主流数据库，熟练常用SQL语句；<br>' +
            '6、熟悉企业OA系统，具备较强的流程梳理能力7.有良好的服务意识、团队协作精神、创新能力及沟通技巧，具备良好的语言和文字表达能力，能承担工作压力。',
        },
        {
          name: '展厅设计师',
          pay: '10-30K/月',
          year: '',
          education: '',
          num: 2,
          duty:
            '1、互动多媒体展厅、小型数字展厅馆、体验中心等的策划及设计；<br>' +
            '2、负责项目前期空间设计及效果图出品控制；<br>' +
            '3、负责后期施工审核，材料的运用、后期现场效果的把控<br>' +
            '4、协同策划确定多媒体数字内容的整体效果；<br>' +
            '5、协同策划和多媒体工程师确定多媒体方案的运用。',
          status:
            '1、本科及以上学历，环境艺术设计、展示设计等相关专业；<br>' +
            '2、两年以上展厅类项目主笔设计经验，或在博物馆、展览馆、科技馆类设计公司担任主创设计师岗位；<br>' +
            '3、熟练掌握CAD、 SKETCHUP、 PHOTOSHOP等各种三维设计软件；<br>' +
            '4、具有较强的沟通能力，能独立汇报方案，配合度高；<br>' +
            '5、熟悉展厅技术和工艺材料；熟悉数字多媒体技术运用大体造价和显示效果；<br>' +
            '6、熟练掌握施工图的读图，可以绘制简单的平面、立面及节点施工表现图，可以对施工图设计提出建议，具有审图能力。',
        },
        {
          name: '展厅展馆策划师',
          pay: '12K-25K/月',
          year: '',
          education: '',
          num: 2,
          duty:
            '1、负责工程建设项目的智慧展厅、智慧安全教育培训展厅的创意策划、统筹主题，与展览路线规划、数字多媒体展示形式设计方案；<br>' +
            '2、能分析客户需求，把握主题和调性，抓住重心，提炼文字，制定策划方案。<br>' +
            '3、从展示角度上，提出合适的富有创新意识和吸引力的展览展示视觉方案。<br>' +
            '4、有良好的表达能力，沟通能力，逻辑思路清晰、观点表达准确。',
          status:
            '1、数字多媒体、展览设计、中文、新闻、美术、广告等相关专业本科或以上学历。<br>' +
            '2、2年以上数字多媒体展厅策划经验；<br>' +
            '3、对数字多媒体展览展示有独到的理解能力，对展览展示空间设计有一定程度的了解；<br>' +
            '4、熟练使用Office、excel、PPT、CAD等软件，熟悉多样的PPT表现形式；',
        },
        {
          name: 'CAD施工图设计师（展厅展馆类）',
          pay: '7-12K/月',
          year: '',
          education: '',
          num: 2,
          duty:
            '1、在主创设计师的指导下完成厅、馆类项目的施工图及CAD深化设计，平立剖面图的绘制；<br>' +
            '2、领会设计师的设计意图，进行施工图深化设计；<br>' +
            '3、能根据展厅3D效果图独立进行施工图编制；<br>' +
            '4、定期去施工现场，查看施工情况，检查施工与图纸要求是否一致，并对施工过程中出现的各类情况：如工程量追加、图纸偏差等，进行适时的设计调整；<br>' +
            '5、施工结束后，根据现场完成竣工图纸的绘制，配合项目经理完成竣工验收；',
          status:
            '1、本科以上学历，建筑装修、室内设计、会展、博物馆及相关专业；<br>' +
            '2、具有本岗位2年以上的工作经验；<br>' +
            '3、熟练掌握AutoCAD、Photoshop等相关软件；<br>' +
            '4、熟悉装饰施工工序，施工工艺及节点构造，了解装饰材料特性，掌握出图规范，熟练绘制施工图；<br>' +
            '5、能够独立完成全套施工图，有较强的施工节点深化能力，有大型项目深化驻场工作经验；',
        },
        {
          name: '平面设计师',
          pay: '7-12K/月',
          year: '',
          education: '',
          num: 2,
          duty:
            '1、负责公司的品牌推广相关的平面设计工作，包括产品宣传页，企业文化设计、LOGO等相关设计工作；<br>' +
            '2、负责公司网页、APP、UI设计及平面宣传视觉维护，公司品牌形象相关设计跟进及维护；<br>' +
            '3、负责展厅展馆项目的CI平面设计工作；<br>' +
            '4、完成上级领导交办的其它工作；',
          status:
            '1、美术艺考生，具备较强的美术功底，本科及以上学历， 2年以上设计相关经验；<br>' +
            '2、熟悉Photoshop，CorelDraw等设计软件；<br>' +
            '3、根据工作要求，独立完成市场宣传资料的创新与设计工作；',
        },
        {
          name: '总经办助理',
          pay: '8-15K/月',
          year: '',
          education: '',
          num: 2,
          duty:
            '1、负责总经办各项会议的组织实施与会议记录，会议决议的签发，并跟进落实；<br>' +
            '2、负责跟踪、汇总各部门月度/季度/年度工作总结与计划；<br>' +
            '3、负责总经理的日常行程安排、来访的接待、商务随行，外出行程安排；<br>' +
            '4、协助总经理处理日常事务及与各职能部门的联络、协调，做好上传下达工作；<br>' +
            '5、完成上级领导交办的其他工作',
          status:
            '1、本科以上学历，行政管理专业、人力资源专业、文秘、工商管理等相关专业；<br>' +
            '2、有行政或、人资、秘书工作经验；<br>' +
            '3、形象气质佳、亲和力强，具备良好的沟通、协调能力；<br>' +
            '4、熟练各类办公软件，具体一定的文案功底、写作能力；<br>' +
            '5、年龄25~35岁',
        },
        {
          name: '培训主管/专员',
          pay: '8-15K/月',
          year: '',
          education: '',
          num: 2,
          duty:
            '1、协助编写培训发展规划，拟订年度工作和培训计划；<br>' +
            '2、负责建立和维护内外部培训渠道和资源，建立内部讲师制度，担任基础培训课程的内部讲师；<br>' +
            '3、负责内部培训需求调查、统计和分析，建立培训体系；<br>' +
            '4、了解各岗位人员发展体系，根据企业战略及人员发展特性设计与企业及部门发展相匹配的培训项目；<br>' +
            '5、组织培训实施工作，负责讲师资源的协调、培训预算支出的控制、对培训活动组织和质量进行全程管理；<br>' +
            '6、负责培训后的调查、分析、评估及培训证书备案等工作，建立健全培训记录档案；<br>' +
            '7、完成上级交办的其它临时性工作',
          status:
            '1、全日制本科及以上学历，人力资源管理相关专业优先；<br>' +
            '2、两年以上企业培训工作经验，具有新能源相关行业人力工作经验优先；<br>' +
            '3、具备专业的培训管理体系知识，熟悉体系建立流程与管理方式；<br>' +
            '4、具备良好的沟通协调能力、组织策划能力，工作认真，具有团队精神。',
        },
        {
          name: '招聘专员',
          pay: '6-8K/月',
          year: '',
          education: '',
          num: 2,
          duty:
            '1、能独立开展招聘工作，分析岗位需求、筛选简历、面试、跟踪招聘结果，保证人员到岗率；<br>' +
            '2、负责日常招聘数据记录及整理工作，能够进行招聘数据分析，提出过程优化建议；<br>' +
            '3、组织、安排面试，进行薪资谈判；<br>' +
            '4、维护人才储备库；<br>' +
            '5、掌握背景调查的基本技巧。',
          status:
            '1、全日制大专以上学历，人力资源管理或工商管理相关专业，形象好气质佳，亲和力强；<br>' +
            '2、2年以上招聘工作经验，有过校招、物联网、工程行业、动画行业等招聘经验者优先考虑；<br>' +
            '3、做事以结果为导向，有目标感，抗压能力强，能够高效完成招聘任务；<br>' +
            '4、熟悉招聘流程，熟练运用各种招聘工具和方法，熟悉国家相关法律法规。<br>' +
            '5、具备较强的责任心，积极主动，团队合作意识强。',
        },
        {
          name: '薪酬专员',
          pay: '5-8K/月',
          year: '',
          education: '',
          num: 2,
          duty:
            '1、负责薪资的核算发放，社会保险、商业保险办理，个税等薪酬基本业务的管理和实施，解决日常的薪酬福利问题，并提供支持和建议。合理规避风险；<br>' +
            '2、负责薪酬数据分析，并提供相应报表；<br>' +
            '3、薪酬调研与薪酬调整。参加外部薪酬调研，并根据市场调研数据与公司薪酬进行分析与评估。并提供年度薪资调整建议方案；<br>' +
            '4、根据公司内部薪资结构，与公司发展需求，不断完善现有的薪酬结构及薪资制度；<br>' +
            '5、协助上级制定各岗位薪酬激励和年终奖励方案。',
          status:
            '1、全日制本科或以上学历，人力资源管理、工商企业管理、心理学等相关专业；<br>' +
            '2、2年以上人力资源工作经验；<br>' +
            '3、熟练运用办公室软件，对函数使用熟练，数据敏感性高，逻辑思维能力好；<br>' +
            '4、具备优秀的人际沟通及协调能力，有较强的抗压能力和主动性，具备极强的责任心和原则性，以及解决问题的能力。',
        },
        {
          name: '招投标主管',
          pay: '8-15K/月',
          year: '',
          education: '',
          num: 2,
          duty:
            '1、制定、修订招投标管理办法及实施细则和相应的操作流程；<br>' +
            '2、负责招投标信息的搜索与整理，收集全国各地招标信息，掌握各地区招标动态，并报市场部负责人；<br>' +
            '3、收集、整理限价信息、提出报价建议，根据项目标的及公司战略目标编制招投标文件；<br>' +
            '4、审核招投标文件及招标合同，负责招投标工作的监督、指导、控制等工作；<br>' +
            '5、收集、汇总区域公司反馈的投标情况，协助并提供各区域公司完成平台对接所需的备案资料。<br>' +
            '6、建立投标总结分析制度,对每项投标结果进行分析,总结经验教训并制定相应的对策方案；<br>' +
            '7、积极配合公司内部其他部门的工作,保守公司客户及供应商的秘密；<br>' +
            '8、领导交办的其他工作。',
          status:
            '1、全日制本科以上学历,工程管理、工程造价等相关专业毕业；<br>' +
            '2、具备三年以上招投标工作经验,具备两年以上招投标部管理经验,熟悉建筑工程行业投标程序；<br>' +
            '3、有工程或者建筑公司从业经验者优先；<br>' +
            '4、责任心强、沟通协调能力强、思路清晰、做事细心周到。',
        },
        {
          name: 'PMC',
          pay: '7-12K/月',
          year: '',
          education: '',
          num: 2,
          duty:
            '1、制定PMC部门职能、职责，建立制定完善的市场销售与生产运作体系及流程（从销售到出货各个环节流程），全面促进生产计划、订单完成交付与销售管理紧密衔接及统一协调；<br>' +
            '2、全面负责统筹管理PMC、采购、仓储全盘工作，与生产制造部门积极沟通，评估产能负荷与效率。根据订单交付进行评审，制定生产计划月排期、周排期、日排期；<br>' +
            '3、掌握生产进度与实际产量(计划产量）、物料进度与生产需求之间的对应关糸，能提前预警及周密考虑，全面促进采购、仓储物流、生产制造、销售等部门业务运作有序紧密协作；<br>' +
            '4、协助生产部进行生产能力、生产技术和效率分析，评估产能，改进生产工艺和流程；<br>' +
            '5、协助生产部制定及提高生产效率改进方案，全面提升生产效率；<br>' +
            '6、监督生产运行物料预订申购、采购物料的催询与进度反馈，确保生产顺利运营，达成订单交付目标；<br>' +
            '7、物料需求计划管理与库存存量的控制，提高周转率，呆滞物料分析、预防与控制；<br>' +
            '8、制定部门培训计划，达到提升员工工作技能和工作态度，进行绩效考核管理，提高员工工作积极性。',
          status:
            '1、大专以上学历；<br>' +
            '2、5年以上电子器械类全盘计划工作经验，其中3年以上计划主管或经理经验；<br>' +
            '3、有金蝶系统操作、ERP系统操作，优化和维护经验，能熟练操作各类常用办公软件；<br>' +
            '4、有较强组织、计划、协调及应变能力。',
        },
        {
          name: '工厂品质IPQC',
          pay: '6-8K/月',
          year: '',
          education: '',
          num: 2,
          duty:
            '1、负责对来料及在制品的检验工作；<br>' +
            '2、负责品质异常的处理跟踪及相关表单制作；<br>' +
            '3、负责生产的质量把关，协调沟通与问题处理；<br>' +
            '4、追溯来料及客诉反馈不良之原因并落实纠正预防措施；<br>' +
            '5、具备现场人员、物料、品质、产量及7S管控能力，并对现场出现的异常有较强的分析处理能力；<br>' +
            '6、负责品质异常的处理跟踪及相关表单制作；<br>' +
            '7、熟悉品质QC七大手法，熟练运用品质相关工具及规则处理品质问题；<br>' +
            '8、熟悉PCBA及五金类物料的检验标准和AOL抽样标准；<br>' +
            '9、负责来料、现场及出货检验工作；<br>' +
            '10、完成领导安排的其他事项。',
          status:
            '1、年龄22-35岁，中专及以上学历；<br>' +
            '2、熟悉电子类产品的检验标准；<br>' +
            '3、一年以上IPQC同等岗位工作经验；<br>' +
            '4、抗压力强，细心、细致；<br>' +
            '5、善于沟通，有良好的计划协调能力及执行能力。',
        },
        {
          name: '售后专员',
          pay: '5-7K/月',
          year: '',
          education: '',
          num: 2,
          duty:
            '1、对客户的售后问题进行汇总、整理、存档；<br>' +
            '2、对产品的换货、退货、补发等售后问题进行登记，并及时通知相关人员处理；<br>' +
            '3、根据公司售后政策，区分质保期项目和收费项目，并及时通知相应业务员；<br>' +
            '4、跟踪、记录售后问题，与公司技术部保持沟通；<br>' +
            '5、电话回访客户，做好客户满意度调查工作。',
          status:
            '1、大专及以上学历，1年以上相关工作经验；<br>' +
            '2、耐心，沟通力好，具有团队意识、客户服务意识，有客户服务相关工作经验者优先。',
        },
        {
          name: '现场工程师',
          pay: '5-8K/月',
          year: '',
          education: '',
          num: 2,
          duty:
            '1、提供产品技术支持，包括咨询解答产品培训现场技术指导故障分析和排除等；<br>' +
            '2、负责市场部与R&D的沟通与信息反馈，参与技术培训和技术研讨会；<br>' +
            '3、收集客户反馈意见，制定市场需求，反馈给R&D，跟踪其进展和市场反应；<br>' +
            '4、制定相关工具软件的作业指导书产品说明书等技术文档；<br>' +
            '5、负责相关技术文档的发放及整理归类；<br>' +
            '6、负责施工现场安装指导工作；<br>' +
            '7、负责硬件产品售前售后技术支持工作；<br>' +
            '8、完成领导安排的其他工作任务。',
          status:
            '1、良好的电子电路分析能力，精通C语言编程，有汇编语言经验；<br>' +
            '2、能熟练应用电子技术，有扎实的电子电路基础，了解常用的拓扑结构；<br>' +
            '3、能熟练运用制图软件，熟悉单片机电子产品开发软件及汇编；<br>' +
            '4、有电子监控系统项目实施经验优先考虑；<br>' +
            '5、良好的沟通能力自学能力及沟通能力。良好的口头表达能力，可以通过电话指导用户处理常见问题；良好的文字表达能力，可以详细记录问题的处理技巧和分析方法。能够承担工作压力，富有团队合作精神；<br>' +
            '6、善于学习，高度责任心和敬业精神，积极向上。',
        },
        {
          name: '结构工程师',
          pay: '8-18K/月',
          year: '',
          education: '',
          num: 2,
          duty:
            '1、跟进项目从产品结构设计，手板确认，开模打样，签样试产，量产等各环节，解决过程中的异常问题点；负责生产装配的指导，提供现场技术支持，对产线装配能够提出优化建议。产品生命周期内全程跟进，优化；主导结构，开模，修模，试产等各环节检讨会议；全程跟进开模，修模过程，对开模，修模提出技术帮助；<br>' +
            '2、根据品质要求，对产品进行可靠性测试，并分析、验证以及确认；<br>' +
            '3、产线支持，制作产品组装说明，产线技术支持与跟进；<br>' +
            '4、文档管理，BOM表的更新与维护，工程图档的输出与归档，以及样品承认书的确认。',
          status:
            '1、大专以上学历，机械设计工科背景；<br>' +
            '2、熟练运用PRO/E、AutoCAD进行外观建模、结构设计以及工程图档输出；<br>' +
            '3、熟悉材料特性，熟悉模具制作流程以及模具各种问题的解决方案；<br>' +
            '4、思维敏捷，学习、动手能力强，工作思路清晰，有条有理，具备项目的分析及评价能力；<br>' +
            '5、优异的创造力，善于沟通和表达，具有较强的团队协作精神。',
        },
        {
          name: '财务助理',
          pay: '5-7K元/月',
          year: '',
          education: '',
          num: 2,
          duty:
            '1、核算核对：核算提成、奖金等；核对相关财务或资产数据；<br>' +
            '2、发票管理：采购发票催收、核对；***领用、开具、登记及资料管理，发票勾选及认证等；<br>' +
            '3、账务处理：协助会计整理单据，处理子公司一般性简单账务；<br>' +
            '4、档案管理：会计凭证、报表、账册的装订及管理；<br>' +
            '5、领导交办的其他事项。',
          status:
            '1、会计学、财经学、审计学、管理学等相关专业，全日制专科及以上学历；<br>' +
            '2、熟悉一般财务相关知识，专业理论扎实，有相关从业经历者优先，欢迎优秀的应届毕业生；<br>' +
            '3、熟练掌握办公软件【word，Excel，PPT等】，EXCEL操作熟练，掌握常规函数运用，如：VLOOKUP，IF，SUMIF，MATCH等；<br>' +
            '4、对数字敏感，财务逻辑思维能力较强；<br>' +
            '5、工作积极主动，有良好的学习能力、沟通协调能力，具有良好的职业操守及团队合作精神，较强的理解、执行和分析能力；' +
            '6、具备诚实、正直的品格，以及细致、严谨的专业精神',
        },
      ],
      cityList: [
        {
          name: '深圳',
          id: 'c_shenzhen',
          title: '深圳总部-深圳市九象数字科技有限公司',
          phone: '0755-88845187',
          email: '37378528@qq.com',
          site: '深圳市福田区八卦二路八卦岭工业区524栋5楼',
          src: require('../assets/images/contact/Shenzhen.png'),
          show: true,
        },
        {
          name: '成都',
          id: 'c_chengdu',
          title: '成都公司-成都九象安控科技有限公司',
          phone: '130 1823 0231',
          email: '',
          site: '四川省成都市高新区环球中心W1区9-1-919',
          src: require('../assets/images/contact/Chengdu.jpg'),
          show: false,
        },
        {
          name: '湖南',
          id: 'c_hunan',
          title: '湖南公司-湖南省九象智联科技有限公司',
          phone: '153 8893 0666',
          email: '',
          site: '长沙市岳麓区梅溪湖创新中心1205—1',
          src: require('../assets/images/contact/Hunan.png'),
          show: false,
        },
        // {
        //     name: "上海",
        //     id: "c_shanghai",
        //     title: "上海公司",
        //     phone: "136 3270 7640",
        //     email: "",
        //     site: "上海市浦东新区杨新东路160号6号楼103-107",
        //     src: require("../assets/images/contact/Shanghai.jpg"),
        //     show: false
        // },
        {
          name: '武汉',
          id: 'c_wuhan',
          title: '武汉公司',
          phone: '153 8893 0666',
          email: '',
          site: '湖北省武汉市洪山区雄楚大道21号校友创新中心13A3',
          src: require('../assets/images/contact/wh.jpg'),
          show: false,
        },
        {
          name: '广州',
          id: 'c_gz',
          title: '广州公司-广州九象数字科技有限公司',
          phone: '136 3267 9764',
          email: '',
          site: '广州市海珠区桥头大街228号乐天智谷B栋3016',
          src: require('../assets/images/contact/gz.jpg'),
          show: false,
        },
        {
          name: '重庆',
          id: 'c_cq',
          title: '重庆九象数字科技有限公司',
          phone: '177 2514 3611',
          email: '',
          site: '重庆两江新区大竹林街道杨柳路3号1幢14层1403',
          src: require('../assets/images/contact/cq.jpg'),
          show: false,
        },
      ],
    }
  },
  methods: {
    changClick(e) {
      let next = e.currentTarget.parentElement.parentElement.nextElementSibling
      if (e.currentTarget.className === 'el-icon-arrow-down') {
        e.currentTarget.className = 'el-icon-arrow-up'
        next.style.display = 'block'
      } else {
        e.currentTarget.className = 'el-icon-arrow-down'
        next.style.display = 'none'
      }
    },
    menuClick(evn) {
      switch (evn) {
        case 1:
          this.top = 0
          this.num = 0
          break
        case 2:
          this.top = document.getElementById('box5').offsetTop
          this.num = 0
          break
      }
      this.top = this.top - 80
      let distanc =
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.pageYOffset
      if (distanc < this.top) {
        this.timer = setInterval(function () {
          window.scrollBy(0, 5)
        }, 1)
      } else {
        this.timer = setInterval(function () {
          window.scrollBy(0, -5)
        }, 1)
      }
    },
    handleScroll: function () {
      let distanc =
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.pageYOffset
      if (distanc > this.top) {
        clearInterval(this.timer)
      }
    },
    getCanvas(e, index) {
      let dom = e.target
      this.cityList.forEach((item) => {
        item.show = false
      })
      this.cityList[index].show = true
      let px = dom.offsetLeft
      let py = dom.offsetTop
      this.initCanvas(px, py)
    },
    initCanvas(px, py) {
      let canvas = document.getElementById('canvas')
      let clientWidth = document.documentElement.clientWidth
      canvas.width = parseInt((clientWidth / 1920) * 670 * 2)
      canvas.height = parseInt((clientWidth / 1920) * 520 * 2)
      let ctx = canvas.getContext('2d')
      ctx.scale(2, 2)
      ctx.strokeStyle = '#fd4351'
      ctx.globalAlpha = 0.8
      ctx.lineWidth = 1
      ctx.clearRect(0, 0, canvas.width, canvas.height)
      ctx.beginPath()
      this.drawDashLine(
        ctx,
        0,
        parseInt((clientWidth / 1920) * 160),
        px + 5,
        py + 5,
        4
      )
    },
    drawDashLine(ctx, x1, y1, x2, y2, dashLen) {
      dashLen = dashLen === undefined ? 5 : dashLen
      //得到斜边的总长度
      let beveling = this.getBeveling(x2 - x1, y2 - y1)
      //计算有多少个线段
      let num = Math.floor(beveling / dashLen)
      for (let i = 0; i < num; i++) {
        ctx[i % 2 == 0 ? 'moveTo' : 'lineTo'](
          x1 + ((x2 - x1) / num) * i,
          y1 + ((y2 - y1) / num) * i
        )
      }
      ctx.stroke()
    },
    getBeveling(x, y) {
      return Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2))
    },
  },
  mounted() {
    let key = this.$route.params.key
    if (key) {
      this.menuClick(key)
    }
    // 默认深圳连线
    let drawShenzhen = document
      .getElementsByClassName('company-pos')[0]
      .getElementsByClassName('c_shenzhen')
    this.initCanvas(drawShenzhen[0].offsetLeft, drawShenzhen[0].offsetTop)
    // 监听屏幕变化，重绘画布和线段
    window.onresize = () => {
      this.initCanvas(drawShenzhen[0].offsetLeft, drawShenzhen[0].offsetTop)
    }
  },
  created() {
    window.addEventListener('scroll', this.handleScroll)
  },
}
</script>

<style lang="scss" scoped>
.box {
  height: 2.9rem;
  width: 100%;
  background: url('../assets/images/banner/contact/1.jpg');
  background-size: 100% 100%;
}

.box2 {
  // width: 12rem;
  // height: 3.8rem;
  // margin: 0.6rem auto 0.92rem;
  // display: flex;
  margin: 0.1rem auto 0.92rem;
  // overflow-x: hidden;

  // .rit {
  //   width: 4.68rem;
  //   text-align: center;
  //   border-top: 2px solid #E70F20;
  //   border-right: 1px solid #eee;
  //   border-bottom: 1px solid #eee;

  //   img.ewm {
  //     width: 1.62rem;
  //     margin-top: 0.2rem;
  //   }

  //   table {
  //     width: 3.8rem;
  //     margin: 0.1rem auto 0;
  //     text-align: left;
  //     font-size: 0.18rem;

  //     td {
  //       vertical-align: top;

  //       i {
  //         color: #E70F20;
  //       }
  //     }
  //   }
  // }

  .distribution {
    position: relative;
    margin: 0 auto;
    min-width: 12rem;
    min-height: 7rem;
    padding-bottom: 0.3rem;
    background: url('../assets/images/contact/map.jpg') center no-repeat;
    background-size: 100% 100%;
    z-index: 1;

    h3 {
      margin-bottom: 0.08rem;
    }

    .wp {
      position: relative;
      padding-top: 0.9rem;
      width: 12rem;
      margin: 0 auto;

      &:after,
      &:before {
        content: '';
        display: block;
        height: 0;
        clear: both;
        visibility: hidden;
      }
    }

    .canvas-area {
      position: absolute;
      left: 5.39rem;
      top: 0.91rem;

      .canvasWp {
        zoom: 0.5;
        transform: scale(1, 1);
      }
    }

    .company-pos {
      position: absolute;
      top: 0;
      left: 0;

      span {
        position: absolute;
        width: 0.08rem;
        height: 0.08rem;
        border-radius: 50%;
        background: #fd4351;
        cursor: pointer;
        transition: all 0.3s;

        &:hover {
          transform: scale(1.2, 1.2);
        }

        i {
          position: absolute;
          width: 0.5rem;
          line-height: 0.24rem;
          height: 0.24rem;
          left: -0.3rem;
          top: -0.28rem;
          border-radius: 0.5rem;
          font-size: 0.12rem;
          text-align: center;
          background: #fd4351;
          color: #fff;

          &:after {
            content: '';
            position: absolute;
            top: 0.22rem;
            right: 0.11rem;
            border-left: 0.06rem solid transparent;
            border-right: 0.06rem solid transparent;
            border-top: 0.06rem solid #fd4351;
          }
        }
      }

      .c_hunan {
        left: 4.7rem;
        top: 3.75rem;
      }

      .c_chengdu {
        left: 3.45rem;
        top: 3.2rem;
      }

      .c_shenzhen {
        left: 5.3rem;
        top: 4.5rem;
      }

      .c_shanghai {
        left: 6rem;
        top: 3.1rem;
      }

      .c_wuhan {
        left: 5rem;
        top: 3.3rem;
      }

      .c_gz {
        left: 4.9rem;
        top: 4.45rem;
      }

      .c_cq {
        left: 4.15rem;
        top: 3.5rem;
      }
    }

    .company-list {
      width: 5.4rem;
      border: 0.01rem solid #ddd;
      border-radius: 0.05rem;
      overflow: hidden;

      .company-item {
        background: #fff;

        img {
          display: block;
          //   height: 3rem;
          width: 100%;
        }

        font-size: 0.15rem;
      }

      h3 {
        font-size: 0.16rem;
        line-height: 1;
        margin-bottom: 0.1rem;
        padding-left: 0.15rem;
        color: #3a3a3a;
      }

      .contact-inner {
        padding: 0.2rem 0.15rem;

        .c-phone,
        .c-email,
        .c-site {
          padding-bottom: 0.05rem;
          padding-left: 0.15rem;
        }
      }
    }
  }
}

.box5 {
  text-align: center;

  .tit {
    font-size: 0.4rem;
    letter-spacing: 3px;
  }

  .bor {
    width: 1rem;
    height: 2px;
    background: #e70f20;
    margin: 0.27rem auto 0.52rem;
  }
}

.box4 {
  text-align: center;
  margin: -0.13rem 0 0.6rem;
}

.box3 {
  width: 10rem;
  margin: 0 auto;

  .main {
    margin-bottom: 0.3rem;

    .job {
      line-height: 0.6rem;
      border: 1px solid #dcdcdc;
      display: flex;
      font-size: 0.18rem;

      .lef {
        width: 3.8rem;
        background: #f9f9f9;
        text-align: center;
        font-size: 0.2rem;
      }

      .lef2 {
        padding-left: 0.48rem;
        width: 3.3rem;
      }

      .lef3 {
        width: 2.25rem;
      }

      i {
        color: #e70f20;
        font-size: 0.24rem;
        font-weight: bold;
      }
    }

    .detail {
      border: 1px solid #dcdcdc;
      border-top: none;
      padding: 0.32rem 0.6rem 0.25rem 0.5rem;
      line-height: 0.4rem;
      display: none;

      p {
        display: flex;

        span {
          display: inline-block;
        }

        span.wid {
          width: 2rem;
        }
      }
    }
  }
}

.info {
  width: 4rem;
  margin: 0.1rem auto;

  &-item {
    font-size: 0.14rem;
    display: flex;
    text-align: left;

    i {
      margin-top: 0.02rem;
      color: #e70f20;
      font-size: 0.2rem;
      font-weight: bold;
      margin-right: 0.1rem;
    }
  }
}
</style>
